<template>
  <div>
    <h4 v-if="showMortgageInformation && typeof mortgageProperty.mortgage !== 'undefined'">Onderpand voor hypotheek:
      {{ mortgageProperty.mortgage.data.hypotheeknummer }}</h4>
    <table class="table table-fixed table-bordered" style="margin-bottom: 15px;border-bottom:none;">
      <tbody>
      <tr>
        <th>Is nieuwbouw</th>
        <td>{{ isNew ? 'Ja' : 'Nee' }}</td>
        <th>Soort nieuwbouw</th>
        <td>{{ newConstructionTypeDescription }}</td>
      </tr>
      <tr>
        <th>Gebruikt voor berekeningen</th>
        <td>{{ mortgageProperty.ltv_calculation ? 'Ja' : 'Nee' }}</td>
      </tr>
      </tbody>
    </table>
    <PropertyShowComponent :propertyObject="mortgageProperty.property.data" :edit="false" v-if="showProperty"/>
  </div>
</template>

<script>
import propertyApi from "~/api/property"
import mortgagePropertyApi from "~/api/mortgage_property"
import PropertyShowComponent from "~/modules/property/components/ShowComponent"

export default {
  name: "MortgagePropertyShowComponent",
  components: {
    PropertyShowComponent
  },
  props: {
    mortgageProperty: {
      type: Object,
      required: true
    },
    showProperty: {
      type: Boolean,
      required: false,
      default: true
    },
    showMortgageInformation: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      isNew: this.mortgageProperty.property.data.collateral_type === 'new',
      newConstructionTypes: {
        '': 'Onbekend',
        collective_private_commissioning: 'CPO',
        diy: 'Zelfbouw',
        project_construction: 'Projectbouw',
      }
    };
  },
  computed: {
    newConstructionTypeDescription() {
      return this.newConstructionTypes[this.mortgageProperty.new_construction_type]
          ? this.newConstructionTypes[this.mortgageProperty.new_construction_type] : 'Onbekend';
    }
  },
  methods: {}
}
</script>
<style scoped>
</style>
